var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 650,
    viewBox: "0 0 626 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M312.982 648.15C485.018 648.15 624.483 503.478 624.483 325.018C624.483 146.557 485.018 1.88647 312.982 1.88647C140.944 1.88647 1.48047 146.557 1.48047 325.018C1.48047 503.478 140.944 648.15 312.982 648.15Z",
    stroke: "url(#paint0_linear_5_442)",
    strokeWidth: 1.82855,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_442",
    x1: 312.936,
    y1: 1.29876,
    x2: 312.936,
    y2: 648.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161A24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#161A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161A24",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector-4.27be0916c7b72407275b3377bb2eb72d.svg";
export { ForwardRef as ReactComponent };